
import { 
  Brain, 
  Activity, 
  FileText,
  MapPin,
  UserCheck,
  Bell,
  ClipboardList
} from "lucide-react";
import type { MenuItem } from "../types";

export const workToolsSection: MenuItem = {
  title: "أدوات العمل",
  href: "#",
  icon: Brain,
  color: "from-purple-500 to-purple-600",
  subItems: [
    {
      title: "إدارة متابعات العملاء",
      href: "/client-follow-up-management",
      icon: UserCheck,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "التذكيرات الذكية",
      href: "/smart-reminders-page",
      icon: Bell,
      color: "from-yellow-500 to-yellow-600",
    },
    {
      title: "سجل الجلسات",
      href: "/session-logs",
      icon: FileText,
      color: "from-indigo-500 to-indigo-600",
    },
    {
      title: "سجل النشاطات",
      href: "/activity-logs",
      icon: Activity,
      color: "from-red-500 to-red-600",
    },
    {
      title: "خريطة تسجيل الموظفين",
      href: "/employee-login-map",
      icon: MapPin,
      color: "from-teal-500 to-teal-600",
    }
  ]
};
